var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"primary split-bg"},[_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":"","lg4":""}},[_c('router-view',{key:_vm.$route.path})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }